import React, { useEffect, useState } from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import { useLocation } from 'react-router-dom';


const Layout = (props) => {
 
  const location = useLocation();

  return (
    <>
      

      <div >
        <Header />
        <Outlet />
            <div style={{ display: location.pathname === `/auctions/room` || location.pathname === `/declarator/room` ? "none" : "block" }}> 
        <Footer />
        </div>
      </div>
      
    </>
  );
};
export default Layout;
